import { InboxFilterState } from 'features/inbox/types/types'
import { applyInboxFilters } from 'features/inbox/utils/filterInspections'
import { useMemo } from 'react'
import { GeckoEntry } from 'types'

interface UseFilteredDataParams {
  inspections: ReadonlyArray<GeckoEntry>
  filters: InboxFilterState
}

interface UseFilteredDataResult {
  inspections: ReadonlyArray<GeckoEntry>
}

/**
 * Hook to provide filtered inspections based on current filter state
 */
export const useFilteredInspections = ({
  inspections,
  filters,
}: UseFilteredDataParams): UseFilteredDataResult => {
  const filteredInspections = useMemo(
    () => applyInboxFilters(inspections, filters),
    [inspections, filters]
  )

  return { inspections: filteredInspections }
}
